var core = module.exports = {version: '2.0.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef